import SplitScreenContent from "../../components/SplitScreenContent";

export const getriebeRevision911964993 = {
  title: "Getriebe-Revision für Porsche 911, 964 & 993",
  titleImageUrl: "gearbox_compressed/7.jpg",
  meta: {
    title:
      "Porsche Getriebe Revision & Überholung – Luftgekühlt | WTM Sportwagen",
    description:
      "Präzise Getrieberevision für luftgekühlte Porsche 911, 964 & 993: WTM Sportwagen überholt 915, G50 & G64 Getriebe originalgetreu, dokumentiert und mit über 30 Jahren Erfahrung.",
  },
  content: [
    {
      type: "hero_image",
      backgroundImage:
        "https://res.cloudinary.com/donwh3eei/image/upload/v1756323587/gallery/frank_kayser/L1013411_2_xh5gzj.jpg",
      headline: "Getriebe-Revision für luftgekühlte Porsche",
      description:
        "Ein Porsche-Getriebe ist mehr als Mechanik – es ist das Herzstück des Fahrerlebnisses. Wir überholen Ihr 915-, G50- oder G64-Getriebe mit höchster Präzision, Erfahrung und Leidenschaft.",
      hasVignette: true,
      overlayOpacity: 0.01,
    },

    {
      type: "text_section_hero",
      // headline: "Getriebe-Revision für luftgekühlte Porsche",
      lead: "Ein Porsche-Getriebe ist mehr als Mechanik – es ist das Herzstück des Fahrerlebnisses. Wir überholen Ihr 915-, G50- oder G64-Getriebe mit höchster Präzision, Erfahrung und Leidenschaft.",
      highlight:
        "Exaktes Schaltgefühl, leise Laufkultur und langfristige Haltbarkeit – wie am ersten Tag.",
      spacing: "tight_top_comfortable_bottom",
      size: "lg",
      variant: "primary",
      margin: false,
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/gearbox_edited/1_cz0jzv",
      headline: "Getriebe-Revision bei WTM",
      rightContent: (
        <SplitScreenContent
          headline="Präzision in jedem Schalt-Vorgang"
          intro="Bei WTM Sportwagen steht jede Getrieberevision für kompromisslose Qualität und handwerkliche Perfektion. Unser Fokus liegt auf luftgekühlten Porsche-Getrieben der Baureihen 911, 964 und 993."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Persönlich & Transparent",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Von Beginn an sind Sie Teil des Projekts: mit klarer Kommunikation, WhatsApp-Updates aus der Werkstatt und echtem persönlichen Austausch. So bleibt Ihre Getrieberevision nachvollziehbar und vertrauensvoll.",
            },
            {
              type: "heading",
              text: "Originalteile & OE-Spezifikation",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Jeder Arbeitsschritt – von der kompletten Zerlegung bis zum finalen Probelauf – folgt höchsten Standards. Keine Abkürzungen, keine Kompromisse. Nur ehrliche, deutsche Handwerksqualität mit Originalteilen.",
            },
            // {
            //   type: "component",
            //   component: "CallToActionWithModalV2",
            //   props: {
            //     headline: "Unverbindlich anfragen – wir beraten Sie persönlich",
            //     paragraph:
            //       "Ob Alltags-911 oder Tracktool – ein gutes Getriebe entscheidet über das gesamte Fahrerlebnis. Wir beraten Sie ehrlich und individuell, auf Wunsch mit deutschlandweitem Hol- & Bringservice.",
            //     darkMode: false,
            //     margin: false,
            //   },
            // },
            {
              type: "image",
              src: "gallery/gearbox_edited/2_aci0te",
              alt: "Präzise Arbeit an Porsche Schaltgetriebe",
              width: 600,
              height: 400,
              highQuality: true,
              wrapperClass: "my-24",
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Getrieberevision - Porsche Getriebe",
      navbarHeight: 0,
    },

    // {
    //   type: "lighthouse-grid",
    //   variant: "secondary",
    //   spacing: "comfortable_top_spacious_bottom",
    //   maxWidth: "none",
    //   showHeader: true,
    //   stickyHeadline: "Getriebe-Revision in Bildern",
    //   title: "Gallerie",
    //   subtitle: "Präzision in jedem Detail",
    //   description:
    //     "Von der Demontage bis zum Wiederaufbau – jede Getrieberevision wird mit höchster Sorgfalt und handwerklicher Perfektion durchgeführt.",
    //   navbarHeight: 0,
    //   images: [
    //     {
    //       src: "gallery/gearbox/7_qjb57i",
    //       alt: "Geöffnetes Porsche Getriebe bei Revision",
    //     },
    //     {
    //       src: "gallery/gearbox/5_jdtgzv",
    //       alt: "Präzise Arbeit an Porsche Schaltgetriebe",
    //     },
    //     {
    //       src: "gallery/gearbox/2_qvquam",
    //       alt: "Getriebekomponenten – Lager, Synchronringe, Wellen",
    //     },
    //     {
    //       src: "gallery/gearbox/3_cnqoug",
    //       alt: "Wiederaufbau Porsche Getriebe",
    //     },
    //     {
    //       src: "gallery/gearbox/4_ns6rux",
    //       alt: "Wiederaufbau Porsche Getriebe - Detailansicht",
    //     },
    //     {
    //       src: "gallery/gearbox/12_lvwkol",
    //       alt: "Wiederaufbau Porsche Getriebe - Fertigstellung",
    //     },
    //   ],
    //   imageWidth: 800,
    //   imageCrop: "fill",
    //   imageGravity: "center",
    //   highQuality: true,
    //   showThumbnails: true,
    // },

    {
      type: "cta-with-modal",
      headline: "Unverbindlich Getriebe-Revision anfragen",
      paragraph:
        "Ein präzises Getriebe macht den Unterschied: Lassen Sie uns über Ihr Projekt sprechen. Wir melden uns persönlich und gehen alle Optionen mit Ihnen durch.",
      darkMode: true,
      spacing: "comfortable_top_tight_bottom",
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/L1013225_2_zye59a",
      headline: "Revision im Detail",
      rightContent: (
        <SplitScreenContent
          headline="So läuft eine Getriebe-Revision bei uns ab"
          intro="Von der Diagnose bis zur Probefahrt – wir dokumentieren jeden Schritt und garantieren höchste Präzision. Viele Schäden kündigen sich früh an – wer rechtzeitig handelt, spart Folgekosten."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Diagnose & Demontage",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Visuelle und technische Prüfung, akustische Tests und bei Bedarf Probefahrt. Zustandsanalyse von Lagern, Wellen, Synchronringen sowie Bewertung aller beweglichen Teile.",
            },
            {
              type: "heading",
              text: "Originalteile & Upgrades",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Wir verbauen ausschließlich geprüfte Ersatzteile – Synchronringe, Schaltgabeln, Lager und Dichtungen in OE-Qualität. Auf Wunsch auch verstärkte Komponenten für Performance oder Track-Einsatz.",
            },
            {
              type: "heading",
              text: "Wiederaufbau & Probelauf",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Nach der Revision wird Ihr Getriebe präzise montiert, mit Porsche-Spezialöl befüllt und ausführlich getestet. Jeder Schritt wird dokumentiert.",
            },
            {
              type: "heading",
              text: "Wann eine Revision sinnvoll ist",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Folgende Probleme sind häufig durch Verschleiß oder Defekte bedingt:",
            },
            {
              type: "list",
              items: [
                "Hakeliges oder schwergängiges Schalten",
                "Knack- oder Mahlgeräusche beim Gangwechsel",
                "Verschlissene Synchronringe (häufig 2. Gang)",
                "Ölaustritt an Dichtungen oder Wellendichtringen",
                "Laufgeräusche bei Teillast oder im Schubbetrieb",
                "Spiel im Schaltgestänge oder unpräziser Schalthebel",
              ],
            },
            //   {
            //     type: "image",
            //     src: "gallery/gearbox_edited/3_mmszj6",
            //     alt: "Wiederaufbau Porsche Getriebe",
            //     width: 600,
            //     height: 400,
            //     highQuality: true,
            //     wrapperClass: "my-24",
            //   },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Getrieberevision - Komponenten",
      navbarHeight: 0,
    },

    {
      type: "split_screen_layout",
      leftImage:
        "gallery/frank_kayser/ChatGPT_Image_Sep_20_2025_02_28_37_PM_q2jzul",
      headline: "Getriebetypen & Spezialisierung",
      rightContent: (
        <SplitScreenContent
          headline="Diese Getriebe überholen wir regelmäßig"
          intro="Jedes Getriebe hat seine Eigenheiten – wir kennen sie alle. Von klassischen 915-Getrieben bis zu modernen G64-Varianten mit Allradantrieb."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Typ 915 (911 G-Modell)",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Das klassische Schaltgetriebe der G-Modelle (2.7 / 3.0 / 3.2 Liter). Robust, aber anfällig für Synchronringverschleiß im 2. Gang. Wir kennen jeden Kniff für eine perfekte Revision.",
            },
            {
              type: "heading",
              text: "Typ G50 (964 Carrera 2)",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Das erste moderne Porsche-Getriebe mit verbesserter Synchronisation. Ideal für Performance-Upgrades und Sperrdifferential-Umbauten.",
            },
            {
              type: "heading",
              text: "Typ G64 (993 Carrera & Turbo)",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Das ausgereifteste luftgekühlte Getriebe – auch in Allrad-Varianten. Besonders beliebt für Track-Umbauten mit kurzen Übersetzungen.",
            },
            {
              type: "heading",
              text: "Sonderumbauten & Upgrades",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Neben der klassischen Revision bieten wir auch den Umbau auf Sperrdifferential und kürzere Achsen – immer mit ehrlicher Beratung und Fokus auf Fahrbarkeit.",
            },
            {
              type: "component",
              component: "IconBulletListV2",
              props: {
                headline: "Warum WTM Sportwagen?",
                items: [
                  "Revision ausschließlich mit Originalteilen oder OE-Spezifikation",
                  "Über 30 Jahre Erfahrung mit 915-, G50- und G64-Getrieben",
                  "Deutschlandweiter Hol- & Bringservice für Getriebe oder Komplettfahrzeuge",
                  "Präzises Schaltgefühl und Geräuschverhalten wie im Neuzustand",
                  "Transparente Dokumentation mit Fotos & Prüfprotokollen",
                ],
                highlightedIndices: [0, 1, 2],
                icon: "check",
              },
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline:
                  "Jetzt Getriebe-Revision besprechen – persönlich & unverbindlich",
                paragraph:
                  "Ein präzises Getriebe macht den Unterschied: Lassen Sie uns über Ihr Projekt sprechen. Wir melden uns persönlich und gehen alle Optionen mit Ihnen durch.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Getrieberevision - Getriebe-Typen",
      navbarHeight: 0,
    },

    {
      type: "relevant-posts",
      postSlugs: [
        "getriebe-revision-ueberblick",
        "porsche-inspektion-haeufigste-verschleissteile",
      ],
      headline: "Werkstatt Journal: Getriebetechnik bei Porsche",
      introText:
        "Lesen Sie mehr über typische Probleme, sinnvolle Upgrades und technische Hintergründe.",
      darkMode: false,
    },
  ],
};
